export const questions = [
    {
        title: "Ninjaz",
        questions: [
            {
                title: "What is Ninjaz?",
                content: "Ninjaz is a leading, premium and swift corporate service provider revolutionizing business setup and corporate management in the UAE and beyond."
            },
            {
                title: "How long has Ninjaz been in operation?",
                content: "Ninjaz has been operating since 2018, helping entrepreneurs and businesses establish and grow in the UAE's dynamic market."
            },
            {
                title: "What sets Ninjaz apart from other business consultants?",
                content: "Ninjaz stands out as the fastest in the market, offering a smart AI-driven digital platform that simplifies and streamlines various business processes and enables quick decision-making. We ensure a transparent end-to-end process while maintaining full compliance – be it either administrative, legal or tax requirements."
            }
        ]
    },
    {
        title: "Business Setup",
        questions: [
            {
                title: "What services does Ninjaz provide for company formation?",
                content: "Ninjaz specializes in assisting with business setup in mainland and free zones across the UAE. We handle documentation, licensing, and guide you through selecting the best business zone for your needs."
            },
            {
                title: "What types of companies can I establish in the UAE?",
                content: "You can set up various entities, including Limited Liability Companies (LLC), Free Zone Companies, Branch Offices, Sole Proprietorships, and Offshore Companies. Ninjaz helps you choose the most suitable structure."
            },
            {
                title: "How long does it take to set up a company in the UAE?",
                content: "Typically, it takes 5 to 10 business days, depending on your business type and location."
            },
            {
                title: "Can I own 100% of my business in the UAE?",
                content: "Yes, 100% foreign ownership is possible in free zones as well as mainland. Ninjaz will help you identify the best setup for full ownership where applicable."
            },
            {
                title: "What is the difference between mainland and free zone business setup?",
                content: "Mainland companies can operate across the UAE and internationally, but free zone companies offer tax benefits and 100% ownership, although their operations within the UAE mainland are limited unless specific arrangements are made."
            },
            {
                title: "How do I choose the right free zone for my business?",
                content: "Ninjaz will evaluate your business activity, location preferences, and other criteria to help you select the ideal free zone. Each zone offers unique incentives and caters to specific industries."
            },
            {
                title: "What is the minimum share capital required to start a business in the UAE?",
                content: "The requirement varies by jurisdiction and company type. Some free zones have no capital requirements, while mainland companies have certain set thresholds depending on the industry and business activities."
            },
            {
                title: "What are the key steps involved in setting up a company in the UAE?",
                content: "Key steps include choosing the business activity, selecting a legal structure, obtaining initial approvals, securing office space, and acquiring a business license. Ninjaz provides support at each stage to streamline the process."
            },
            {
                title: "Is it mandatory to have a physical office for my business in the UAE?",
                content: "Depends, but usually it is preferred to have a physical or virtual office for most business setups. Ninjaz can help you secure an appropriate office space based on your needs."
            }
        ]
    },
    {
        title: "Pricing and Costs",
        questions: [
            {
                title: "What are the costs involved in setting up a business in the UAE?",
                content: "Costs depend on factors like business structure, licensing, and location. Ninjaz offers transparent pricing and advises on cost-effective solutions based on your needs."
            },
            {
                title: "Are there ongoing fees for maintaining a business in the UAE?",
                content: "Yes, there are annual fees for license renewals, office leases, and compliance services. Ninjaz assists with managing these requirements efficiently."
            },
            {
                title: "Are there any hidden fees I should be aware of during the business setup process?",
                content: "Ninjaz prides itself on transparency. All costs will be outlined upfront, including government fees, licensing charges, and any additional services you choose. We ensure there are no hidden charges so you can budget accurately for your business setup."
            },
            {
                title: "What factors influence the cost of setting up a business in the UAE?",
                content: "Several factors impact the cost, including the type of business, the location (mainland vs. free zone), the number of visas required, office space costs, and any additional services like PRO or legal support. Ninjaz offers a customized pricing plan to match your specific business needs."
            },
            {
                title: "Can I get a free consultation to understand the costs better?",
                content: "Yes, Ninjaz offers a free initial consultation to discuss your business setup options and provide you with a clear breakdown of costs tailored to your specific requirements."
            },
            {
                title: "Are the costs different for setting up a business in mainland vs. a free zone?",
                content: "Yes, the costs vary between mainland and free zones. Free zones often have lower upfront costs and offer benefits like 100% foreign ownership, but mainland companies provide greater flexibility in terms of business operations. Ninjaz helps you assess the cost differences to make the best decision for your business."
            }
        ]
    },
    {
        title: "Admin, PRO and Visa Services",
        questions: [
            {
                title: "Does Ninjaz offer PRO (Public Relations Officer) services?",
                content: "Yes, we provide full PRO services, including handling government-related documentation for visas, labor contracts, work permits, trade licenses, and more."
            },
            {
                title: "What are PRO services, and why do I need them?",
                content: "PRO services include interactions with government authorities for essential documentation like visas and licenses, ensuring your business operates smoothly and complies with regulations."
            },
            {
                title: "What specific PRO services does Ninjaz provide?",
                content: "We handle visa applications, trade license renewals, labor contracts, work permits, document attestation and other government-related tasks."
            },
            {
                title: "Can Ninjaz handle both individual and corporate PRO services?",
                content: "Yes, we offer comprehensive PRO services for both individual entrepreneurs and corporate entities."
            },
            {
                title: "Can Ninjaz help with obtaining visas for my employees?",
                content: "Yes, Ninjaz provides comprehensive visa processing services for business owners, employees, and their families. We handle all aspects of visa applications, renewals, and cancellations, ensuring a smooth process with minimal delays."
            },
            {
                title: "What types of visas can Ninjaz assist with?",
                content: "Ninjaz assists with various types of visas, including: Investor/Partner Visas, Employee Visas, Dependent Visas (for family members), Freelancer Visas, Golden Visas (for long-term residency)"
            },
            {
                title: "How long does it take to process a UAE visa?",
                content: "The visa processing time can vary depending on the type of visa and the number of applications. Typically, visas take between 7 to 10 business days once all documents are submitted. Ninjaz expedites the process to ensure timely approvals."
            },
            {
                title: "Does Ninjaz assist with visa renewals?",
                content: "Yes, Ninjaz manages the entire visa renewal process for business owners, employees, and dependents. We track the expiration dates and handle the paperwork to ensure timely renewals without any penalties or delays."
            },
            {
                title: "Can Ninjaz help with visa cancellations?",
                content: "Absolutely. Ninjaz assists with visa cancellations for employees and business owners who no longer require their visas, ensuring compliance with UAE regulations and smooth transitions."
            },
            {
                title: "What is the process for applying for a dependent visa in the UAE?",
                content: "To sponsor family members, you will need documents such as the sponsor’s passport, residency visa, salary certificate, tenancy contract, and proof of relationship (e.g., marriage or birth certificates). Ninjaz will assist you in gathering these documents, attestations and submitting the application."
            },
            {
                title: "Can I sponsor a visa for domestic staff through Ninjaz’s PRO services?",
                content: "Yes, Ninjaz can help you sponsor visas for domestic workers such as maids, drivers, and nannies, ensuring that all legal requirements are met."
            },
            {
                title: "How many visas can I obtain under my business?",
                content: "The number of visas your business can obtain depends on factors such as your office space, business activity, and your company’s trade license along with the allocation and quota. Ninjaz can help determine your company’s eligibility and manage the visa process accordingly."
            }
        ]
    },
    {
        title: "Legal and Compliance",
        questions: [
            {
                title: "What legal support does Ninjaz provide during the business setup process?",
                content: "Ninjaz ensures that your business adheres to UAE regulations from the start. We guide you through legal requirements for licensing, company formation, and local sponsorship, if applicable, and help structure your business in compliance with UAE laws."
            },
            {
                title: "Can Ninjaz assist with drafting and reviewing legal documents?",
                content: "Yes, we offer support in drafting and reviewing essential legal documents such as power of attorneys, partnership agreements, employment contracts, non-disclosure agreements, and vendor contracts, ensuring they comply with UAE law."
            },
            {
                title: "How does Ninjaz help ensure my business stays compliant with UAE regulations?",
                content: "Ninjaz provides ongoing compliance monitoring and reporting services to ensure that your business meets all local regulations, including renewals of trade licenses, tax filings, visas, and regulatory obligations."
            },
            {
                title: "What are the penalties for non-compliance, and how can Ninjaz help avoid them?",
                content: "Non-compliance with UAE laws can lead to penalties such as fines, license suspension, or visa revocations. Ninjaz helps you stay compliant by monitoring deadlines for renewals, updating documents as needed, and ensuring that your business adheres to changing regulations."
            },
            {
                title: "Can Ninjaz assist with resolving legal disputes?",
                content: "Yes, while Ninjaz primarily focuses on business setup, management and compliance, we can also assist in resolving business disputes by connecting you with specialized legal experts for complex issues."
            },
            {
                title: "What are the key compliance requirements for businesses operating in the UAE?",
                content: "Key compliance requirements include maintaining an active trade license, timely filing of VAT returns (if applicable), ensuring visa renewals, adhering to labor laws, and ensuring proper financial records. Ninjaz helps manage all these aspects to keep your business fully compliant."
            },
            {
                title: "Does Ninjaz offer auditing services for legal and compliance matters?",
                content: "While Ninjaz does not conduct legal audits directly, we work with trusted partners to perform legal and compliance audits, ensuring your business is meeting all regulatory requirements and avoiding potential risks."
            }
        ]
    },
    {
        title: "Accounting and Tax",
        questions: [
            {
                title: "Does Ninjaz offer VAT registration and filing services?",
                content: "Yes, we assist with VAT registration and compliance, ensuring your business adheres to UAE tax regulations and helps you file VAT returns accurately."
            },
            {
                title: "Do you offer ongoing accounting and bookkeeping services?",
                content: "Yes, Ninjaz provides full accounting and bookkeeping services, offering accurate financial reports and ensuring compliance with UAE laws."
            },
            {
                title: "Can Ninjaz assist with VAT audits and consultations?",
                content: "We connect you to our trusted partners to provide support during VAT audits and consultations to help your businesses maintain compliance with the latest tax laws."
            },
            {
                title: "What is the corporate tax rate in the UAE?",
                content: "As of June 2023, the UAE introduced a federal corporate tax rate of 9% on taxable income exceeding AED 375,000, aimed at businesses operating within the UAE. Ninjaz helps businesses navigate these regulations and ensures compliance with the new corporate tax laws."
            },
            {
                title: "How does Ninjaz assist with corporate tax compliance?",
                content: "Ninjaz provides comprehensive support for corporate tax compliance, including tax registrations, preparing and filing tax returns, and ensuring adherence to regulations. We keep you informed about deadlines and any changes in tax laws to maintain compliance."
            },
            {
                title: "Are there any exemptions or incentives available for businesses regarding corporate tax?",
                content: "Yes, certain categories of businesses, such as those operating in free zones, may qualify for tax incentives or exemptions. Ninjaz can help determine if your business is eligible for these benefits and ensure you take full advantage of them."
            },
            {
                title: "What documentation is required for corporate tax filing?",
                content: "Key documents required for corporate tax filing include financial statements, accounting records, and any relevant tax declarations. Ninjaz assists in organizing these documents to facilitate accurate and timely filing."
            },
            {
                title: "What are the penalties for failing to comply with corporate tax regulations in the UAE?",
                content: "Non-compliance with corporate tax regulations can lead to penalties, including fines and interest on unpaid taxes. Ninjaz helps mitigate these risks by ensuring your business adheres to all tax obligations."
            },
            {
                title: "How often do businesses need to file corporate tax returns in the UAE?",
                content: "Businesses are generally required to file annual corporate tax returns in the UAE. Ninjaz assists in preparing these returns and ensures they are submitted on time to avoid any penalties."
            }
        ]
    },
    {
        title: "Banking",
        questions: [
            {
                title: "Does Ninjaz assist with opening a bank account?",
                content: "Yes, Ninjaz offers comprehensive support in opening both personal and business bank accounts in the UAE. Our team guides you through the entire process, ensuring you understand the requirements and gather the necessary documentation, making the process smooth and efficient."
            },
            {
                title: "What documents are needed to open a business bank account in the UAE?",
                content: "Typically, you will need to provide several documents, including a valid trade license, passport copies of all shareholders, proof of residency (like a utility bill), a business plan, etc. Ninjaz helps ensure that you have all required documentation in order."
            },
            {
                title: "How long does it take to open a bank account in the UAE?",
                content: "The timeline can vary, but it generally takes around 3 to 4 weeks to open a business bank account. This duration depends on the bank’s internal and compliance processes and how quickly you can provide the necessary documents. Ninjaz will assist in expediting the process wherever possible."
            },
            {
                title: "Can Ninjaz recommend banks for business accounts?",
                content: "Absolutely! Ninjaz can recommend a selection of banks tailored to your business needs, whether you require specific services, such as online banking or international transactions. Our team stays updated on the offerings from various banks to ensure you choose the best option for your operations."
            }
        ]
    },
];
